(function () {
  'use strict';

  var IMAGE_CACHE = Object.create(null);
  var PENDING_HANDLES = Object.create(null);
  var scheduledFrame = null;
  var observer = null;

  function isBoostPage() {
    var path = window.location.pathname || '';
    return path.indexOf('/collections/') === 0 || path.indexOf('/search') === 0;
  }

  function isBrokenImageSrc(src) {
    if (!src) return true;
    if (src.indexOf('{{') !== -1) return true;
    if (src.indexOf('boost-pfs-no-image') !== -1) return true;
    return false;
  }

  function getProductHandle(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return '';

    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function buildImageUrl(src, width) {
    if (!src) return '';
    var url = src.split('?')[0];
    return url + '?width=' + width;
  }

  function fetchProductImage(handle) {
    if (!handle) return Promise.resolve('');
    if (IMAGE_CACHE[handle]) return Promise.resolve(IMAGE_CACHE[handle]);
    if (PENDING_HANDLES[handle]) return PENDING_HANDLES[handle];

    var root = window.routes && window.routes.rootUrlWithoutSlash !== undefined
      ? window.routes.rootUrlWithoutSlash
      : '';
    var request = fetch(root + '/products/' + encodeURIComponent(handle) + '.json')
      .then(function (response) {
        if (!response.ok) throw new Error('Product JSON request failed');
        return response.json();
      })
      .then(function (data) {
        var product = data && data.product ? data.product : null;
        var image = product && (product.image || (product.images && product.images[0]));
        var src = image && image.src ? image.src : '';
        if (src) IMAGE_CACHE[handle] = src;
        return src;
      })
      .catch(function () {
        return '';
      })
      .then(function (src) {
        delete PENDING_HANDLES[handle];
        return src;
      });

    PENDING_HANDLES[handle] = request;
    return request;
  }

  function applyImage(img, src) {
    if (!img || !src) return;

    var width = 400;
    var optimizedSrc = buildImageUrl(src, width);
    var optimizedSrcset = [
      buildImageUrl(src, 200) + ' 200w',
      buildImageUrl(src, 300) + ' 300w',
      buildImageUrl(src, 400) + ' 400w',
      buildImageUrl(src, 600) + ' 600w',
    ].join(', ');

    img.removeAttribute('data-boost-image-fallback');
    img.onerror = null;
    img.src = optimizedSrc;
    img.srcset = optimizedSrcset;
    img.sizes = '(max-width: 749px) 50vw, 25vw';
    img.loading = img.getAttribute('loading') || 'lazy';
    img.decoding = 'async';
  }

  function repairImage(img, item) {
    if (!img || img.getAttribute('data-boost-image-fallback') === 'pending') return;

    var currentSrc = img.currentSrc || img.src || '';
    if (!isBrokenImageSrc(currentSrc)) return;

    var handle = getProductHandle(item);
    if (!handle) return;

    img.setAttribute('data-boost-image-fallback', 'pending');

    fetchProductImage(handle).then(function (src) {
      if (!src) {
        img.removeAttribute('data-boost-image-fallback');
        return;
      }
      applyImage(img, src);
    });
  }

  function repairProductItem(item) {
    if (!item) return;

    var images = item.querySelectorAll('.boost-sd__product-image-img, .boost-sd__product-image img');
    if (!images.length) return;

    images.forEach(function (img) {
      repairImage(img, item);
    });
  }

  function repairAll(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.boost-sd__product-item');
    items.forEach(repairProductItem);
  }

  function scheduleRepair(root) {
    if (scheduledFrame !== null) return;

    var run = function () {
      scheduledFrame = null;
      repairAll(root);
    };

    if (window.requestAnimationFrame) {
      scheduledFrame = window.requestAnimationFrame(run);
    } else {
      scheduledFrame = window.setTimeout(run, 50);
    }
  }

  function observeBoostList() {
    var list = document.querySelector('.boost-sd__filter-product-list');
    if (!list || !window.MutationObserver) return;

    if (observer) observer.disconnect();

    observer = new MutationObserver(function () {
      scheduleRepair(list);
    });

    observer.observe(list, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    if (!isBoostPage()) return;

    scheduleRepair(document);
    observeBoostList();

    document.addEventListener('heritage:market:changed', function () {
      window.setTimeout(function () {
        scheduleRepair(document);
      }, 300);
    });

    document.addEventListener('heritage:market:recover', function () {
      window.setTimeout(function () {
        scheduleRepair(document);
      }, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
